/**
 * Contracts and caravans (GDD §6): a contract fixes what, how much, at what
 * price (or for what in barter) and how many deliveries; a caravan ship
 * carries each delivery across the map, where it can be robbed. No exchange
 * fee, and both sides earn trade income — the exporter twice as much.
 * Starting values for tuning.
 */
export const TRADE = {
  /**
   * Trade income per delivery, as a share of its value in ГС: the exporter
   * gets it twice, the importer once (GDD §6: «экспортёру ×2, импортёру ×1»).
   */
  tradeIncome: 0.1,
  exporterIncomeFactor: 2,
  importerIncomeFactor: 1,
  /** Active contracts a player may hold by commerce center level 1/2/3 (none without one). */
  slotsByCommerceLevel: [1, 2, 3],
  /** Deliveries one contract may promise. */
  maxDeliveries: 20,
  /** A seller who misses this many deliveries in a row breaks the contract. */
  missedToBreak: 2,
  /** Reputation lost by whoever breaks a contract (GDD §6). */
  breachPenalty: 10,
  /**
   * Direct transfers between players lose this share on the way (GDD §12:
   * no king-making); they are visible to everyone.
   */
  transferTax: 0.5,
} as const;
